export const USER_ENDPOINTS = {
  profile: '/user/profile',
} as const;
